import { createFileRoute } from '@tanstack/react-router'
import { AgentDashboard } from '../../../../components/AgentDashboard'

export const Route = createFileRoute('/platform/desa/$desaId/agen')({
  component: () => {
    const { desaId } = Route.useParams()
    return <AgentDashboard desaId={desaId} />
  },
})
